export let AssetsType = [
  { code: 'CA', name: 'Car' },
  { code: 'LA', name: 'Laptop' },
  { code: 'DK', name: 'Monitor' },
  { code: 'MO', name: 'Mobile' },
  { code: 'SI', name: 'SIM' },
  { code: 'FC', name: 'Fuel Card' },
  { code: 'OA', name: 'Other' },
];
